import { createSlice } from "@reduxjs/toolkit";

const DEFAULT_DAYS_MEALS = {
  lunes: {
    desayuno: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Leche" },
      { cantidad: 2, unidad_medida: "Rebanada", alimento: "Pan integral" }
    ],
    merienda_matutina: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Yogur natural" },
      { cantidad: 5, unidad_medida: "Unidad", alimento: "Almendras" }
    ],
    almuerzo: [
      { cantidad: 1, unidad_medida: "Plato", alimento: "Arroz con pollo" },
      { cantidad: 1, unidad_medida: "Taza", alimento: "Ensalada verde" }
    ],
    merienda_vespertina: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Leche" },
      { cantidad: 1, unidad_medida: "Cucharada", alimento: "Avena" }
    ],
    cena: [{ cantidad: 1, unidad_medida: "Plato", alimento: "Ensalada César" }]
  },
  martes: {
    desayuno: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Avena" },
      { cantidad: 1, unidad_medida: "Unidad", alimento: "Banana" }
    ],
    merienda_matutina: [
      { cantidad: 1, unidad_medida: "Unidad", alimento: "Barra de cereal" }
    ],
    almuerzo: [
      { cantidad: 1, unidad_medida: "Plato", alimento: "Pasta con carne" }
    ],
    merienda_vespertina: [
      {
        cantidad: 1,
        unidad_medida: "Taza",
        alimento: "Batido de chocolate"
      }
    ],
    cena: [
      {
        cantidad: 1,
        unidad_medida: "Plato",
        alimento: "Sándwich de pollo"
      }
    ]
  },
  miercoles: {
    desayuno: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Café" },
      {
        cantidad: 3,
        unidad_medida: "Unidad",
        alimento: "Galletas integrales"
      }
    ],
    merienda_matutina: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Frutas mixtas" }
    ],
    almuerzo: [
      { cantidad: 1, unidad_medida: "Plato", alimento: "Sopa de verduras" },
      { cantidad: 1, unidad_medida: "Unidad", alimento: "Pan integral" }
    ],
    merienda_vespertina: [
      { cantidad: 1, unidad_medida: "Unidad", alimento: "Manzana" }
    ],
    cena: [{ cantidad: 1, unidad_medida: "Plato", alimento: "Sopa de pollo" }]
  },
  jueves: {
    desayuno: [
      { cantidad: 1, unidad_medida: "Vaso", alimento: "Jugo de naranja" },
      { cantidad: 2, unidad_medida: "Unidad", alimento: "Huevos" }
    ],
    merienda_matutina: [
      { cantidad: 1, unidad_medida: "Unidad", alimento: "Banana" }
    ],
    almuerzo: [
      {
        cantidad: 1,
        unidad_medida: "Plato",
        alimento: "Filete de pescado"
      },
      { cantidad: 1, unidad_medida: "Taza", alimento: "Arroz blanco" }
    ],
    merienda_vespertina: [
      {
        cantidad: 1,
        unidad_medida: "Taza",
        alimento: "Infusión de hierbas"
      }
    ],
    cena: [
      {
        cantidad: 1,
        unidad_medida: "Plato",
        alimento: "Tortilla española"
      }
    ]
  },
  viernes: {
    desayuno: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Té verde" },
      { cantidad: 1, unidad_medida: "Unidad", alimento: "Manzana" }
    ],
    merienda_matutina: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Jugo de piña" }
    ],
    almuerzo: [
      { cantidad: 1, unidad_medida: "Plato", alimento: "Carne guisada" },
      { cantidad: 1, unidad_medida: "Taza", alimento: "Puré de papas" }
    ],
    merienda_vespertina: [
      {
        cantidad: 1,
        unidad_medida: "Unidad",
        alimento: "Barra de granola"
      }
    ],
    cena: [
      { cantidad: 1, unidad_medida: "Plato", alimento: "Ensalada de atún" }
    ]
  },
  sabado: {
    desayuno: [
      {
        cantidad: 1,
        unidad_medida: "Taza",
        alimento: "Chocolate caliente"
      },
      {
        cantidad: 2,
        unidad_medida: "Rebanada",
        alimento: "Pan con mantequilla"
      }
    ],
    merienda_matutina: [
      { cantidad: 6, unidad_medida: "Unidad", alimento: "Galletas" }
    ],
    almuerzo: [
      {
        cantidad: 1,
        unidad_medida: "Plato",
        alimento: "Pizza de vegetales"
      }
    ],
    merienda_vespertina: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Té verde" }
    ],
    cena: [{ cantidad: 1, unidad_medida: "Plato", alimento: "Hamburguesa" }]
  },
  domingo: {
    desayuno: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Leche" },
      { cantidad: 2, unidad_medida: "Unidad", alimento: "Arepas" }
    ],
    merienda_matutina: [
      { cantidad: 1, unidad_medida: "Taza", alimento: "Batido de fresa" }
    ],
    almuerzo: [{ cantidad: 1, unidad_medida: "Plato", alimento: "Paella" }],
    merienda_vespertina: [
      { cantidad: 1, unidad_medida: "Unidad", alimento: "Yogur" }
    ],
    cena: [{ cantidad: 1, unidad_medida: "Plato", alimento: "Sushi" }]
  }
};

const initialState = {
  isLoading: false,
  dietModels: [],
  dietModel: null,
  formData: {
    name: "",
    description: "",
    days: DEFAULT_DAYS_MEALS
  },
  error: null
};

const dietModelSlice = createSlice({
  name: "dietModel",
  initialState,
  reducers: {
    setDietModels: (state, action) => {
      state.dietModels = action.payload;
    },
    setDietModel: (state, action) => {
      state.dietModel = action.payload;
      state.formData = action.payload;
    },
    addDietModel: (state, action) => {
      state.dietModels.push(action.payload);
    },
    updateDietModel: (state, action) => {
      const index = state.dietModels.findIndex(
        item => item.id === action.payload.id
      );
      if (index !== -1) {
        state.dietModels[index] = {
          ...state.dietModels[index],
          ...action.payload
        };
      }
    },
    removeDietModel: (state, action) => {
      state.dietModels = state.dietModels.filter(
        item => item.id !== action.payload
      );
    },
    updateField: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },
    updateDayMeal: (state, action) => {
      const { day, meals } = action.payload;
      state.formData.days[day] = meals;
    },
    resetForm: state => {
      state.formData = initialState.formData;
    }
  },
  selectors: {
    selectFormData: state => state.formData,
    selectDietModels: state => state.dietModels,
    selectDietModel: state => state.dietModel
  }
});

export const {
  setDietModel,
  setDietModels,
  addDietModel,
  updateDietModel,
  removeDietModel,
  updateField,
  updateDayMeal,
  resetForm
} = dietModelSlice.actions;

export const {
  selectFormData,
  selectDietModels,
  selectDietModel
} = dietModelSlice.selectors;

export default dietModelSlice.reducer;
